import React, { useState } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Row,
  Col,
  Input,
} from '@lockerpm/design';

import {
  SearchOutlined
} from "@ant-design/icons";

const Filter = (props) => {
  const { t } = useTranslation()
  const {
    className = '',
    params = {},
    setParams = () => { }
  } = props;

  const [key, setKey] = useState(params.key)

  return (
    <Row
      className={`filter ${className}`}
      justify={'space-between'}
      gutter={[0, 8]}
    >
      <Col lg={24} className="w-full">
        <Row
          justify={'left'}
          gutter={[12, 12]}
        >
          <Col xl={4} lg={6} md={8} xs={12}>
            <p className="font-semibold mb-1">{t('secret.key')}</p>
            <Input
              prefix={<SearchOutlined />}
              value={key}
              placeholder={t('placeholder.enter')}
              onChange={(e) => {
                setKey(e.target.value);
                setParams({ ...params, key: e.target.value })
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Filter;
